import {Injectable} from '@angular/core';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {Configurations} from 'projects/shared/src/lib/services/configurations';

@Injectable({
  providedIn: 'root'
})
export class GoogleTagService {

  constructor(
    private gtmService: GoogleTagManagerService,
    private config: Configurations
  ) {
  }

  event(event: any) {
    const gtmTag = {event};
    if (!this.config.env.isProd) {
      return new Promise(resolve => resolve(true));
    }
    return this.gtmService.pushTag(gtmTag);
  }

  addGtmToDom() {
    return this.gtmService.addGtmToDom();
  }
}
